

export function FeatureCard({ img, label }: { img: any; label: string }) {


    return (
        <div className="feature-card">
            <div className="card-icon">
                {img}
            </div>
            <p className="para-14 color-black bold-500 mt-3">{label}</p>
        </div>
    );
}